import { render, staticRenderFns } from "./orderconfirm.vue?vue&type=template&id=5f0b1326&scoped=true"
import script from "./orderconfirm.vue?vue&type=script&lang=ts"
export * from "./orderconfirm.vue?vue&type=script&lang=ts"
import style0 from "./orderconfirm.vue?vue&type=style&index=0&id=5f0b1326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b1326",
  null
  
)

export default component.exports